import { useQuery } from "@tanstack/react-query";

import { listPosts, type PostVisibility } from "@/adapters/api";
import { chartKeys } from "../utils/query-keys.ts";

const STALE_TIME = 60_000;
const RECENT_POSTS = 3;

export interface UseRecentPostsParams {
	constructionId: string | undefined;
	visibility?: PostVisibility;
	enabled?: boolean;
}

export function useRecentPosts({
	constructionId,
	visibility,
	enabled = true,
}: UseRecentPostsParams) {
	return useQuery({
		queryKey: chartKeys.recentPosts(constructionId, visibility),
		queryFn: async () => {
			const response = await listPosts({
				constructionId,
				visibility,
				page: 1,
				pageSize: RECENT_POSTS,
			});
			return response.items;
		},
		enabled: enabled && !!constructionId,
		staleTime: STALE_TIME,
	});
}
